import { PublicRoute, Router } from '@core/router';
import React, { lazy, memo } from 'react';
import { Route, Switch } from 'react-router-dom';
const ShortURLMainPage = lazy(() => import('@modules/dashboard/DashboardPage/ShortURLMainPage'));
const NotFroundPage = lazy(() => import('@modules/pages/NotFroundPage'));
const UnauthorizedPage = lazy(() => import('@modules/pages/UnauthorizedPage'));
const SchedulePage = lazy(() => import('@modules/CalendarPage/SchedulePage'));
const NylasIframePage = lazy(() => import('@modules/CalendarPage/NylasIframePage'));

export const ShortAppRouter = memo(() => (
  <div>
    <Router>
      <Switch>
        <PublicRoute exact path={['/:slug/reschedule/:event', '/:slug/cancel/:event']} component={NylasIframePage} />
        <PublicRoute exact path="/:tid/:uname/:slug?" component={SchedulePage} />
        <PublicRoute exact path="/404" component={NotFroundPage} />
        <PublicRoute exact path={['/401', '/401-external']} component={UnauthorizedPage} />

        <PublicRoute path="/" component={ShortURLMainPage} />

        <Route component={NotFroundPage} />
      </Switch>
    </Router>
  </div>
));
